function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ACTION_TYPES = {
  signature: 'signature',
  initial: 'initial',
  date: 'date'
};
function emptyDocument() {
  return {
    document: {
      name: '',
      pdf: [],
      page_count: 0,
      page_width: 0,
      page_height: 0
    },
    users: [],
    actions: [],
    creator: '',
    finalized: false,
    finalization: null,
    edited: false
  };
}
function isPdf(file) {
  var name = String((file === null || file === void 0 ? void 0 : file.name) || '').toLowerCase();
  var type = String((file === null || file === void 0 ? void 0 : file.type) || '').toLowerCase();
  return type === 'application/pdf' || name.endsWith('.pdf');
}
function pdfEntries(record) {
  var _record$document;
  return Array.isArray(record === null || record === void 0 || (_record$document = record.document) === null || _record$document === void 0 ? void 0 : _record$document.pdf) ? record.document.pdf : [];
}
function hasPdf(record) {
  return pdfEntries(record).some(function (entry) {
    return entry && String(entry.pdf || '').trim();
  });
}
function summarizePdfs(record, pdfs) {
  var _list$, _list$2, _list$3;
  var list = Array.isArray(pdfs) ? pdfs : [];
  record.document.pdf = list;
  record.document.name = ((_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.name) || 'document.pdf';
  record.document.page_count = list.reduce(function (total, entry) {
    return total + (Number(entry.page_count) || 0);
  }, 0);
  record.document.page_width = Number((_list$2 = list[0]) === null || _list$2 === void 0 ? void 0 : _list$2.page_width) || 0;
  record.document.page_height = Number((_list$3 = list[0]) === null || _list$3 === void 0 ? void 0 : _list$3.page_height) || 0;
  return record;
}
function pageSource(record, page) {
  var wanted = Number(page);
  if (!Number.isInteger(wanted) || wanted < 1) {
    return null;
  }
  var remaining = wanted;
  var list = pdfEntries(record);
  for (var index = 0; index < list.length; index += 1) {
    var entry = list[index];
    var count = Number(entry === null || entry === void 0 ? void 0 : entry.page_count) || 0;
    if (remaining <= count) {
      return {
        entry: entry,
        index: index,
        localPage: remaining
      };
    }
    remaining -= count;
  }
  return null;
}
function revoke(record) {
  pdfEntries(record).forEach(function (entry) {
    if (entry !== null && entry !== void 0 && entry.url && typeof URL.revokeObjectURL === 'function') {
      URL.revokeObjectURL(entry.url);
    }
    if (entry) {
      entry.url = '';
    }
  });
}
function canEdit(record, actorKey) {
  return Boolean(record && !record.finalized && record.creator && String(actorKey || '').trim() === String(record.creator).trim());
}
function addUser(record, name, actorKey) {
  if (!canEdit(record, actorKey)) {
    return -1;
  }
  record.users.push({
    name: String(name || '').trim(),
    email: '',
    publickey: '',
    verifications: [],
    signatures: []
  });
  record.edited = true;
  return record.users.length - 1;
}
function isEmailAddress(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}
function sameLabel(a, b) {
  return String(a || '').trim().toLowerCase().replace(/\s+/g, ' ') === String(b || '').trim().toLowerCase().replace(/\s+/g, ' ');
}
function signerEmail(user) {
  var email = String((user === null || user === void 0 ? void 0 : user.email) || '').trim();
  if (isEmailAddress(email)) {
    return email.toLowerCase();
  }
  var name = String((user === null || user === void 0 ? void 0 : user.name) || '').trim();
  if (isEmailAddress(name)) {
    return name.toLowerCase();
  }
  return '';
}
function resolveSigner(record, value, explicitName) {
  var exceptIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
  var raw = String(value || '').trim();
  var providedName = String(explicitName == null ? raw : explicitName).trim();
  if (!raw && !providedName) {
    return {
      action: 'ignore'
    };
  }
  var emailKey = (isEmailAddress(raw) ? raw : isEmailAddress(providedName) ? providedName : '').toLowerCase();
  if (!emailKey) {
    return {
      action: 'create',
      name: providedName || raw
    };
  }
  var index = ((record === null || record === void 0 ? void 0 : record.users) || []).findIndex(function (user, i) {
    return i !== exceptIndex && signerEmail(user) === emailKey;
  });
  if (index < 0) {
    return {
      action: 'create',
      name: providedName || raw
    };
  }
  var existingName = String(record.users[index].name || '').trim();
  var conflict = explicitName != null && !sameLabel(providedName, existingName) && !sameLabel(providedName, emailKey);
  return {
    action: 'existing',
    index: index,
    conflict: conflict
  };
}
function renameUser(record, index, name, actorKey) {
  if (!canEdit(record, actorKey)) {
    return;
  }
  var user = record.users[index];
  var next = String(name || '').trim();
  if (!user || !next || user.name === next) {
    return;
  }
  user.name = next;
  record.edited = true;
}
function removeUser(record, index, actorKey) {
  if (!canEdit(record, actorKey)) {
    return;
  }
  if (!record.users[index]) {
    return;
  }
  record.users.splice(index, 1);
  record.actions = record.actions.filter(function (action) {
    return action.user !== index;
  }).map(function (action) {
    return _objectSpread(_objectSpread({}, action), {}, {
      user: action.user > index ? action.user - 1 : action.user
    });
  });
  stripSignatures(record);
  record.edited = true;
}
function addAction(record, action, actorKey) {
  if (!canEdit(record, actorKey)) {
    return null;
  }
  var id = record.actions.reduce(function (max, item) {
    return Math.max(max, Number(item.id) || 0);
  }, 0) + 1;
  var next = {
    id: id,
    type: ACTION_TYPES[action.type] ? action.type : 'signature',
    user: action.user,
    page: action.page,
    x: action.x,
    y: action.y,
    width: action.width,
    height: action.height
  };
  var group = String(action.group || '').trim();
  if (group) {
    next.group = group;
  }
  record.actions.push(next);
  stripSignatures(record);
  record.edited = true;
  return next;
}
function stripSignatures(record) {
  (record.users || []).forEach(function (user) {
    user.signatures = [];
  });
}
function actionById(record, id) {
  var wanted = Number(id);
  return record.actions.find(function (action) {
    return action.id === wanted;
  }) || null;
}
function removeAction(record, id, actorKey) {
  if (!canEdit(record, actorKey)) {
    return;
  }
  var wanted = Number(id);
  var target = record.actions.find(function (action) {
    return action.id === wanted;
  });
  if (!target) {
    return;
  }
  var group = String(target.group || '').trim();
  var before = record.actions.length;
  record.actions = group ? record.actions.filter(function (action) {
    return String(action.group || '').trim() !== group;
  }) : record.actions.filter(function (action) {
    return action.id !== wanted;
  });
  if (record.actions.length !== before) {
    record.edited = true;
  }
}
function actionsOnPage(record, page) {
  return record.actions.filter(function (action) {
    return action.page === page;
  });
}
function copyVerification(entry) {
  var next = {
    method: entry.method || '',
    publickey: entry.publickey || '',
    message: entry.message || '',
    signature: entry.signature || ''
  };
  var photo = typeof entry.photo === 'string' ? entry.photo : '';
  if (photo) {
    next.photo = photo;
  }
  var image = typeof entry.image === 'string' ? entry.image : '';
  if (image) {
    next.image = image;
  }
  return next;
}
function copyPdfEntry(entry) {
  return {
    name: (entry === null || entry === void 0 ? void 0 : entry.name) || '',
    pdf: (entry === null || entry === void 0 ? void 0 : entry.pdf) || '',
    page_count: (entry === null || entry === void 0 ? void 0 : entry.page_count) || 0,
    page_width: (entry === null || entry === void 0 ? void 0 : entry.page_width) || 0,
    page_height: (entry === null || entry === void 0 ? void 0 : entry.page_height) || 0
  };
}
function copy(record) {
  var _record$document2, _pdfs$, _record$document3, _record$document4, _pdfs$2, _record$document5, _pdfs$3;
  var pdfs = pdfEntries(record).map(copyPdfEntry);
  var next = {
    document: {
      name: ((_record$document2 = record.document) === null || _record$document2 === void 0 ? void 0 : _record$document2.name) || ((_pdfs$ = pdfs[0]) === null || _pdfs$ === void 0 ? void 0 : _pdfs$.name) || '',
      pdf: pdfs,
      page_count: ((_record$document3 = record.document) === null || _record$document3 === void 0 ? void 0 : _record$document3.page_count) || pdfs.reduce(function (total, entry) {
        return total + (entry.page_count || 0);
      }, 0),
      page_width: ((_record$document4 = record.document) === null || _record$document4 === void 0 ? void 0 : _record$document4.page_width) || ((_pdfs$2 = pdfs[0]) === null || _pdfs$2 === void 0 ? void 0 : _pdfs$2.page_width) || 0,
      page_height: ((_record$document5 = record.document) === null || _record$document5 === void 0 ? void 0 : _record$document5.page_height) || ((_pdfs$3 = pdfs[0]) === null || _pdfs$3 === void 0 ? void 0 : _pdfs$3.page_height) || 0
    },
    users: (record.users || []).map(function (user) {
      return {
        name: user.name || '',
        email: user.email || '',
        publickey: user.publickey || '',
        verifications: (user.verifications || []).map(function (entry) {
          return copyVerification(entry);
        }),
        signatures: (user.signatures || []).map(function (entry) {
          var next = {
            id: entry.id,
            signature: entry.signature || ''
          };
          if (entry.document_hash) {
            next.document_hash = String(entry.document_hash);
          }
          return next;
        })
      };
    }),
    actions: (record.actions || []).map(function (action) {
      var next = {
        id: action.id,
        type: action.type,
        user: action.user,
        page: action.page,
        x: action.x,
        y: action.y,
        width: action.width,
        height: action.height
      };
      var group = String(action.group || '').trim();
      if (group) {
        next.group = group;
      }
      return next;
    })
  };
  next.creator = String(record.creator || '');
  next.finalized = record.finalized === true;
  next.finalization = record.finalization ? JSON.parse(JSON.stringify(record.finalization)) : null;
  next.creatorProof = record.creatorProof ? JSON.parse(JSON.stringify(record.creatorProof)) : null;
  next.hash = String(record.hash || '');
  if (record !== null && record !== void 0 && record.metadata && _typeof(record.metadata) === 'object') {
    next.metadata = JSON.parse(JSON.stringify(record.metadata));
  }
  return next;
}
function openPdf(_x) {
  return _openPdf.apply(this, arguments);
}
function _openPdf() {
  _openPdf = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, openPdfs([file]));
      }
    }, _callee);
  }));
  return _openPdf.apply(this, arguments);
}
function openPdfs(_x2) {
  return _openPdfs.apply(this, arguments);
}
function _openPdfs() {
  _openPdfs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(files) {
    var record, list, _iterator2, _step2, file, _t, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          record = emptyDocument();
          list = [];
          _iterator2 = _createForOfIteratorHelper(files || []);
          _context2.p = 1;
          _iterator2.s();
        case 2:
          if ((_step2 = _iterator2.n()).done) {
            _context2.n = 5;
            break;
          }
          file = _step2.value;
          _t = list;
          _context2.n = 3;
          return readFile(file);
        case 3:
          _t.push.call(_t, _context2.v);
        case 4:
          _context2.n = 2;
          break;
        case 5:
          _context2.n = 7;
          break;
        case 6:
          _context2.p = 6;
          _t2 = _context2.v;
          _iterator2.e(_t2);
        case 7:
          _context2.p = 7;
          _iterator2.f();
          return _context2.f(7);
        case 8:
          if (list.length) {
            _context2.n = 9;
            break;
          }
          throw new Error('not a pdf');
        case 9:
          return _context2.a(2, summarizePdfs(record, list));
      }
    }, _callee2, null, [[1, 6, 7, 8]]);
  }));
  return _openPdfs.apply(this, arguments);
}
function hydrate(_x3) {
  return _hydrate.apply(this, arguments);
}
function _hydrate() {
  _hydrate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(saved) {
    var _saved$finalization, _saved$document, _saved$document2;
    var record, entries, list, _iterator3, _step3, _saved$document3, entry, _t3, _t4;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          record = emptyDocument();
          record.users = Array.isArray(saved.users) ? saved.users : [];
          record.actions = Array.isArray(saved.actions) ? saved.actions : [];
          record.creator = String(saved.creator || '');
          record.finalized = saved.finalized === true || Boolean((_saved$finalization = saved.finalization) === null || _saved$finalization === void 0 ? void 0 : _saved$finalization.signature);
          record.finalization = saved.finalization && _typeof(saved.finalization) === 'object' ? saved.finalization : null;
          record.creatorProof = saved.creatorProof && _typeof(saved.creatorProof) === 'object' ? saved.creatorProof : null;
          record.hash = String(saved.hash || '');
          record.edited = saved.edited === true || record.actions.length > 0;
          if (saved.metadata && _typeof(saved.metadata) === 'object') {
            record.metadata = saved.metadata;
          }
          entries = Array.isArray((_saved$document = saved.document) === null || _saved$document === void 0 ? void 0 : _saved$document.pdf) ? saved.document.pdf : [];
          list = [];
          _iterator3 = _createForOfIteratorHelper(entries);
          _context3.p = 1;
          _iterator3.s();
        case 2:
          if ((_step3 = _iterator3.n()).done) {
            _context3.n = 5;
            break;
          }
          entry = _step3.value;
          _t3 = list;
          _context3.n = 3;
          return readBase64((entry === null || entry === void 0 ? void 0 : entry.pdf) || '', (entry === null || entry === void 0 ? void 0 : entry.name) || ((_saved$document3 = saved.document) === null || _saved$document3 === void 0 ? void 0 : _saved$document3.name) || 'document.pdf');
        case 3:
          _t3.push.call(_t3, _context3.v);
        case 4:
          _context3.n = 2;
          break;
        case 5:
          _context3.n = 7;
          break;
        case 6:
          _context3.p = 6;
          _t4 = _context3.v;
          _iterator3.e(_t4);
        case 7:
          _context3.p = 7;
          _iterator3.f();
          return _context3.f(7);
        case 8:
          if (list.length) {
            _context3.n = 9;
            break;
          }
          throw new Error('not a pdf');
        case 9:
          summarizePdfs(record, list);
          if ((_saved$document2 = saved.document) !== null && _saved$document2 !== void 0 && _saved$document2.name) {
            record.document.name = saved.document.name;
          }
          return _context3.a(2, record);
      }
    }, _callee3, null, [[1, 6, 7, 8]]);
  }));
  return _hydrate.apply(this, arguments);
}
function readFile(_x4) {
  return _readFile.apply(this, arguments);
}
function _readFile() {
  _readFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(file) {
    var bytes, _t5, _t6;
    return _regenerator().w(function (_context4) {
      while (1) switch (_context4.n) {
        case 0:
          _t5 = Uint8Array;
          _context4.n = 1;
          return file.arrayBuffer();
        case 1:
          _t6 = _context4.v;
          bytes = new _t5(_t6);
          return _context4.a(2, describe(bytes, file.name || 'document.pdf'));
      }
    }, _callee4);
  }));
  return _readFile.apply(this, arguments);
}
function readBase64(_x5, _x6) {
  return _readBase.apply(this, arguments);
}
function _readBase() {
  _readBase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(pdf, name) {
    var bytes;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.n) {
        case 0:
          bytes = Uint8Array.from(Buffer.from(pdf, 'base64'));
          return _context5.a(2, describe(bytes, name || 'document.pdf'));
      }
    }, _callee5);
  }));
  return _readBase.apply(this, arguments);
}
function describe(_x7, _x8) {
  return _describe.apply(this, arguments);
}
function _describe() {
  _describe = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(bytes, name) {
    var text, file, _pageSize, _pageSize2, page_width, page_height, _t7, _t8, _t9, _t0, _t1, _t10;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          text = binaryString(bytes);
          if (text.slice(0, 1024).includes('%PDF')) {
            _context6.n = 1;
            break;
          }
          throw new Error('not a pdf');
        case 1:
          file = new File([bytes], name, {
            type: 'application/pdf'
          });
          _pageSize = pageSize(text), _pageSize2 = _slicedToArray(_pageSize, 2), page_width = _pageSize2[0], page_height = _pageSize2[1];
          _t7 = name;
          _t8 = Buffer.from(bytes).toString('base64');
          _context6.n = 2;
          return readPageCount(text);
        case 2:
          _t9 = _context6.v;
          _t0 = page_width;
          _t1 = page_height;
          _t10 = typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function' ? URL.createObjectURL(file) : '';
          return _context6.a(2, {
            name: _t7,
            pdf: _t8,
            page_count: _t9,
            page_width: _t0,
            page_height: _t1,
            url: _t10
          });
      }
    }, _callee6);
  }));
  return _describe.apply(this, arguments);
}
function readPageCount(_x9) {
  return _readPageCount.apply(this, arguments);
} // Page trees are often stored in compressed object streams, so a plaintext
// search never sees /Type /Pages or /Count. The count lives on the catalog's
// root Pages node.
function _readPageCount() {
  _readPageCount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(text) {
    var count, _t11;
    return _regenerator().w(function (_context7) {
      while (1) switch (_context7.p = _context7.n) {
        case 0:
          _context7.p = 0;
          _context7.n = 1;
          return pageCountFromStructure(text);
        case 1:
          count = _context7.v;
          if (!(count >= 1)) {
            _context7.n = 2;
            break;
          }
          return _context7.a(2, count);
        case 2:
          _context7.n = 4;
          break;
        case 3:
          _context7.p = 3;
          _t11 = _context7.v;
        case 4:
          return _context7.a(2, countPagesFromText(text));
      }
    }, _callee7, null, [[0, 3]]);
  }));
  return _readPageCount.apply(this, arguments);
}
function pageCountFromStructure(_x0) {
  return _pageCountFromStructure.apply(this, arguments);
}
function _pageCountFromStructure() {
  _pageCountFromStructure = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(text) {
    var xref, cache, streams, root, marker, start, catalog, pagesRef, pages, count, _t12;
    return _regenerator().w(function (_context8) {
      while (1) switch (_context8.n) {
        case 0:
          xref = new Map();
          cache = new Map();
          streams = new Map();
          root = null;
          marker = text.lastIndexOf('startxref');
          start = marker >= 0 ? text.slice(marker).match(/startxref\s+(\d+)/) : null;
          if (start) {
            _context8.n = 1;
            break;
          }
          throw new Error('startxref');
        case 1:
          _context8.n = 2;
          return ingestXref(text, Number(start[1]), xref, function (next) {
            root = next;
          });
        case 2:
          if (root) {
            _context8.n = 3;
            break;
          }
          throw new Error('root');
        case 3:
          _context8.n = 4;
          return loadObject(text, xref, cache, streams, root);
        case 4:
          catalog = _context8.v;
          pagesRef = catalog && catalog.Pages;
          if (!(pagesRef && pagesRef.obj != null)) {
            _context8.n = 6;
            break;
          }
          _context8.n = 5;
          return loadObject(text, xref, cache, streams, pagesRef);
        case 5:
          _t12 = _context8.v;
          _context8.n = 7;
          break;
        case 6:
          _t12 = pagesRef;
        case 7:
          pages = _t12;
          count = pages && pages.Count;
          if (!(typeof count !== 'number' || count < 1)) {
            _context8.n = 8;
            break;
          }
          throw new Error('count');
        case 8:
          return _context8.a(2, count);
      }
    }, _callee8);
  }));
  return _pageCountFromStructure.apply(this, arguments);
}
function ingestXref(_x1, _x10, _x11, _x12) {
  return _ingestXref.apply(this, arguments);
}
function _ingestXref() {
  _ingestXref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(text, offset, xref, setRoot) {
    var seen, readAt, _readAt;
    return _regenerator().w(function (_context0) {
      while (1) switch (_context0.n) {
        case 0:
          _readAt = function _readAt3() {
            _readAt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(at) {
              var i, table, _iterator4, _step4, entry, record, loaded, dict;
              return _regenerator().w(function (_context9) {
                while (1) switch (_context9.n) {
                  case 0:
                    if (!seen.has(at)) {
                      _context9.n = 1;
                      break;
                    }
                    return _context9.a(2);
                  case 1:
                    seen.add(at);
                    i = skipSpace(text, at);
                    if (!text.startsWith('xref', i)) {
                      _context9.n = 3;
                      break;
                    }
                    table = parseClassicXref(text, i);
                    if (!table.trailer.Prev) {
                      _context9.n = 2;
                      break;
                    }
                    _context9.n = 2;
                    return readAt(table.trailer.Prev);
                  case 2:
                    _iterator4 = _createForOfIteratorHelper(table.entries);
                    try {
                      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                        entry = _step4.value;
                        xref.set(entry.obj, entry);
                      }
                    } catch (err) {
                      _iterator4.e(err);
                    } finally {
                      _iterator4.f();
                    }
                    if (table.trailer.Root) {
                      setRoot(table.trailer.Root);
                    }
                    return _context9.a(2);
                  case 3:
                    record = readFileObject(text, i);
                    _context9.n = 4;
                    return materialize(record);
                  case 4:
                    loaded = _context9.v;
                    dict = loaded.dict || record.value;
                    if (!dict.Prev) {
                      _context9.n = 5;
                      break;
                    }
                    _context9.n = 5;
                    return readAt(dict.Prev);
                  case 5:
                    applyXrefStream(dict, loaded.bytes, xref);
                    if (dict.Root) {
                      setRoot(dict.Root);
                    }
                  case 6:
                    return _context9.a(2);
                }
              }, _callee9);
            }));
            return _readAt.apply(this, arguments);
          };
          readAt = function _readAt2(_x25) {
            return _readAt.apply(this, arguments);
          };
          seen = new Set();
          _context0.n = 1;
          return readAt(offset);
        case 1:
          return _context0.a(2);
      }
    }, _callee0);
  }));
  return _ingestXref.apply(this, arguments);
}
function applyXrefStream(dict, bytes, xref) {
  var widths = dict.W;
  if (!widths || !bytes) {
    throw new Error('xref stream');
  }
  var typeW = widths[0] || 0;
  var offW = widths[1] || 0;
  var genW = widths[2] || 0;
  var width = typeW + offW + genW;
  var index = dict.Index || [0, dict.Size];
  var cursor = 0;
  for (var section = 0; section < index.length; section += 2) {
    var obj = index[section];
    var count = index[section + 1];
    for (var n = 0; n < count; n += 1, obj += 1) {
      var row = bytes.subarray(cursor, cursor + width);
      cursor += width;
      var type = typeW ? readInt(row, 0, typeW) : 1;
      var field2 = offW ? readInt(row, typeW, offW) : 0;
      var field3 = genW ? readInt(row, typeW + offW, genW) : 0;
      if (type === 1) {
        xref.set(obj, {
          obj: obj,
          type: 1,
          offset: field2,
          gen: field3
        });
      } else if (type === 2) {
        xref.set(obj, {
          obj: obj,
          type: 2,
          stream: field2,
          index: field3
        });
      } else {
        xref.set(obj, {
          obj: obj,
          type: 0
        });
      }
    }
  }
}
function loadObject(_x13, _x14, _x15, _x16, _x17) {
  return _loadObject.apply(this, arguments);
}
function _loadObject() {
  _loadObject = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(text, xref, cache, streams, ref) {
    var id, entry, list, _value, record, value, result;
    return _regenerator().w(function (_context1) {
      while (1) switch (_context1.n) {
        case 0:
          id = ref.obj;
          if (!cache.has(id)) {
            _context1.n = 1;
            break;
          }
          return _context1.a(2, cache.get(id));
        case 1:
          entry = xref.get(id);
          if (!(!entry || entry.type === 0)) {
            _context1.n = 2;
            break;
          }
          return _context1.a(2, null);
        case 2:
          if (!(entry.type === 2)) {
            _context1.n = 4;
            break;
          }
          _context1.n = 3;
          return loadObjectStream(text, xref, cache, streams, entry.stream);
        case 3:
          list = _context1.v;
          _value = list[entry.index];
          cache.set(id, _value);
          return _context1.a(2, _value);
        case 4:
          record = readFileObject(text, entry.offset);
          _context1.n = 5;
          return materialize(record);
        case 5:
          value = _context1.v;
          result = record.stream ? value : record.value;
          cache.set(id, result);
          return _context1.a(2, result);
      }
    }, _callee1);
  }));
  return _loadObject.apply(this, arguments);
}
function loadObjectStream(_x18, _x19, _x20, _x21, _x22) {
  return _loadObjectStream.apply(this, arguments);
}
function _loadObjectStream() {
  _loadObjectStream = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(text, xref, cache, streams, id) {
    var loaded, dict, bytes, header, nums, objects, n, start, end, piece;
    return _regenerator().w(function (_context10) {
      while (1) switch (_context10.n) {
        case 0:
          if (!streams.has(id)) {
            _context10.n = 1;
            break;
          }
          return _context10.a(2, streams.get(id));
        case 1:
          _context10.n = 2;
          return loadObject(text, xref, cache, streams, {
            obj: id,
            gen: 0
          });
        case 2:
          loaded = _context10.v;
          dict = loaded.dict || loaded;
          bytes = loaded.bytes;
          header = binaryString(bytes.subarray(0, dict.First));
          nums = header.trim().split(/\s+/).map(Number);
          objects = [];
          for (n = 0; n < dict.N; n += 1) {
            start = dict.First + nums[n * 2 + 1];
            end = n + 1 < dict.N ? dict.First + nums[(n + 1) * 2 + 1] : bytes.length;
            piece = binaryString(bytes.subarray(start, end));
            objects.push(parseValue(piece, 0).value);
          }
          streams.set(id, objects);
          return _context10.a(2, objects);
      }
    }, _callee10);
  }));
  return _loadObjectStream.apply(this, arguments);
}
function readFileObject(text, offset) {
  var i = skipSpace(text, offset);
  var head = text.slice(i).match(/^(\d+)\s+(\d+)\s+obj\s*/);
  if (!head) {
    throw new Error('obj');
  }
  i += head[0].length;
  var parsed = parseValue(text, i);
  i = skipSpace(text, parsed.index);
  if (!text.startsWith('stream', i)) {
    return {
      value: parsed.value,
      stream: null
    };
  }
  var length = parsed.value && parsed.value.Length;
  if (typeof length !== 'number') {
    throw new Error('stream length');
  }
  i += 'stream'.length;
  if (text[i] === '\r') {
    i += 1;
  }
  if (text[i] === '\n') {
    i += 1;
  }
  return {
    value: parsed.value,
    stream: bytesAt(text, i, length)
  };
}
function materialize(_x23) {
  return _materialize.apply(this, arguments);
}
function _materialize() {
  _materialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(record) {
    var bytes, filter, filters, parms;
    return _regenerator().w(function (_context11) {
      while (1) switch (_context11.n) {
        case 0:
          if (record.stream) {
            _context11.n = 1;
            break;
          }
          return _context11.a(2, record.value);
        case 1:
          bytes = record.stream;
          filter = record.value.Filter;
          filters = Array.isArray(filter) ? filter : filter ? [filter] : [];
          if (!filters.includes('FlateDecode')) {
            _context11.n = 3;
            break;
          }
          _context11.n = 2;
          return inflateFlate(bytes);
        case 2:
          bytes = _context11.v;
          parms = decodeParms(record.value);
          if (parms && parms.Predictor >= 10) {
            bytes = unpredict(bytes, parms.Columns || 1);
          }
        case 3:
          return _context11.a(2, {
            dict: record.value,
            bytes: bytes
          });
      }
    }, _callee11);
  }));
  return _materialize.apply(this, arguments);
}
function decodeParms(dict) {
  var parms = dict.DecodeParms;
  if (!parms) {
    return null;
  }
  if (Array.isArray(parms)) {
    return parms.find(function (item) {
      return item && item.Predictor;
    }) || parms[0];
  }
  return parms;
}
function inflateFlate(_x24) {
  return _inflateFlate.apply(this, arguments);
}
function _inflateFlate() {
  _inflateFlate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(bytes) {
    var stream, _t13, _t14;
    return _regenerator().w(function (_context12) {
      while (1) switch (_context12.n) {
        case 0:
          stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('deflate'));
          _t13 = Uint8Array;
          _context12.n = 1;
          return new Response(stream).arrayBuffer();
        case 1:
          _t14 = _context12.v;
          return _context12.a(2, new _t13(_t14));
      }
    }, _callee12);
  }));
  return _inflateFlate.apply(this, arguments);
}
function unpredict(data, columns) {
  var rowSize = columns + 1;
  var rows = Math.floor(data.length / rowSize);
  var out = new Uint8Array(rows * columns);
  var previous = new Uint8Array(columns);
  for (var row = 0; row < rows; row += 1) {
    var filter = data[row * rowSize];
    var current = new Uint8Array(columns);
    for (var column = 0; column < columns; column += 1) {
      var raw = data[row * rowSize + 1 + column];
      var left = column > 0 ? current[column - 1] : 0;
      var up = previous[column];
      var upLeft = column > 0 ? previous[column - 1] : 0;
      var value = raw;
      if (filter === 1) {
        value = raw + left & 255;
      } else if (filter === 2) {
        value = raw + up & 255;
      } else if (filter === 3) {
        value = raw + (left + up >> 1) & 255;
      } else if (filter === 4) {
        var estimate = left + up - upLeft;
        var pa = Math.abs(estimate - left);
        var pb = Math.abs(estimate - up);
        var pc = Math.abs(estimate - upLeft);
        var predicted = pa <= pb && pa <= pc ? left : pb <= pc ? up : upLeft;
        value = raw + predicted & 255;
      }
      current[column] = value;
    }
    out.set(current, row * columns);
    previous = current;
  }
  return out;
}
function readInt(bytes, offset, width) {
  var value = 0;
  for (var i = 0; i < width; i += 1) {
    value = value * 256 + bytes[offset + i];
  }
  return value;
}

// TextDecoder('latin1') is windows-1252 in browsers, so bytes 0x80-0x9F do not
// round-trip. PDF streams have to stay byte-for-byte or FlateDecode fails.
function binaryString(bytes) {
  var text = '';
  for (var i = 0; i < bytes.length; i += 4096) {
    text += String.fromCharCode.apply(null, bytes.subarray(i, i + 4096));
  }
  return text;
}
function bytesAt(text, start, length) {
  var out = new Uint8Array(length);
  for (var i = 0; i < length; i += 1) {
    out[i] = text.charCodeAt(start + i) & 255;
  }
  return out;
}
function parseClassicXref(text, i) {
  i = skipSpace(text, i) + 4;
  var entries = [];
  while (true) {
    i = skipSpace(text, i);
    if (text.startsWith('trailer', i)) {
      break;
    }
    var subsection = text.slice(i).match(/^(\d+)\s+(\d+)\s*/);
    if (!subsection) {
      break;
    }
    i += subsection[0].length;
    var first = Number(subsection[1]);
    var count = Number(subsection[2]);
    for (var n = 0; n < count; n += 1) {
      var line = text.slice(i).match(/^(\d+)\s+(\d+)\s+([nf])\s*/);
      if (!line) {
        throw new Error('xref line');
      }
      entries.push({
        obj: first + n,
        type: line[3] === 'n' ? 1 : 0,
        offset: Number(line[1]),
        gen: Number(line[2])
      });
      i += line[0].length;
    }
  }
  var trailer = parseValue(text, i + 'trailer'.length).value;
  return {
    entries: entries,
    trailer: trailer
  };
}
function parseValue(text, i) {
  i = skipSpace(text, i);
  if (text.startsWith('<<', i)) {
    return parseDict(text, i);
  }
  if (text[i] === '[') {
    return parseArray(text, i);
  }
  if (text[i] === '(') {
    return parseLiteral(text, i);
  }
  if (text[i] === '<') {
    return parseHex(text, i);
  }
  if (text[i] === '/') {
    return parseName(text, i);
  }
  if (text.startsWith('true', i)) {
    return {
      value: true,
      index: i + 4
    };
  }
  if (text.startsWith('false', i)) {
    return {
      value: false,
      index: i + 5
    };
  }
  if (text.startsWith('null', i)) {
    return {
      value: null,
      index: i + 4
    };
  }
  var number = text.slice(i).match(/^[+-]?(?:\d+\.\d*|\.\d+|\d+)/);
  if (!number) {
    throw new Error('value');
  }
  var raw = number[0];
  var index = i + raw.length;
  if (!raw.includes('.')) {
    var ref = text.slice(index).match(/^\s+(\d+)\s+R(?![\w])/);
    if (ref) {
      return {
        value: {
          obj: Number(raw),
          gen: Number(ref[1])
        },
        index: index + ref[0].length
      };
    }
  }
  return {
    value: Number(raw),
    index: index
  };
}
function parseDict(text, i) {
  var dict = {};
  i += 2;
  while (true) {
    i = skipSpace(text, i);
    if (text.startsWith('>>', i)) {
      return {
        value: dict,
        index: i + 2
      };
    }
    var name = parseName(text, i);
    var parsed = parseValue(text, name.index);
    dict[name.value] = parsed.value;
    i = parsed.index;
  }
}
function parseArray(text, i) {
  var values = [];
  i += 1;
  while (true) {
    i = skipSpace(text, i);
    if (text[i] === ']') {
      return {
        value: values,
        index: i + 1
      };
    }
    var parsed = parseValue(text, i);
    values.push(parsed.value);
    i = parsed.index;
  }
}
function parseName(text, i) {
  var index = i + 1;
  var name = '';
  while (index < text.length && !' \n\r\t\f<>[]()/%'.includes(text[index])) {
    if (text[index] === '#') {
      name += String.fromCharCode(parseInt(text.slice(index + 1, index + 3), 16));
      index += 3;
      continue;
    }
    name += text[index];
    index += 1;
  }
  return {
    value: name,
    index: index
  };
}
function parseLiteral(text, i) {
  var depth = 1;
  i += 1;
  while (i < text.length && depth) {
    if (text[i] === '\\') {
      i += 2;
      continue;
    }
    if (text[i] === '(') {
      depth += 1;
    } else if (text[i] === ')') {
      depth -= 1;
    }
    i += 1;
  }
  return {
    value: '',
    index: i
  };
}
function parseHex(text, i) {
  var end = text.indexOf('>', i + 1);
  return {
    value: '',
    index: end + 1
  };
}
function skipSpace(text, i) {
  while (i < text.length) {
    var c = text[i];
    if (c === ' ' || c === '\n' || c === '\r' || c === '\t' || c === '\f' || c === '\0') {
      i += 1;
      continue;
    }
    if (c === '%') {
      while (i < text.length && text[i] !== '\n' && text[i] !== '\r') {
        i += 1;
      }
      continue;
    }
    break;
  }
  return i;
}
function countPagesFromText(text) {
  var counts = [];
  var markers = text.matchAll(/\/Type\s*\/Pages\b/g);
  var _iterator = _createForOfIteratorHelper(markers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var marker = _step.value;
      var forward = text.slice(marker.index, marker.index + 400);
      var count = forward.match(/\/Count\s+(\d+)/);
      if (!count) {
        var backward = text.slice(Math.max(0, marker.index - 80), marker.index);
        var found = _toConsumableArray(backward.matchAll(/\/Count\s+(\d+)/g));
        count = found.length ? found[found.length - 1] : null;
      }
      if (count) {
        counts.push(Number(count[1]));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (counts.length) {
    return Math.max.apply(Math, counts);
  }
  var linear = text.slice(0, 4096).match(/\/Linearized[\s\S]{0,160}?\/N\s+(\d+)/);
  if (linear) {
    return Math.max(1, Number(linear[1]));
  }
  var pages = text.match(/\/Type\s*\/Page(?!s)\b/g);
  if (pages && pages.length) {
    return pages.length;
  }
  return 1;
}
function pageSize(text) {
  var box = text.match(/\/MediaBox\s*\[\s*([0-9.]+)\s+([0-9.]+)\s+([0-9.]+)\s+([0-9.]+)\s*\]/);
  if (!box) {
    return [612, 792];
  }
  var width = Math.abs(Number(box[3]) - Number(box[1]));
  var height = Math.abs(Number(box[4]) - Number(box[2]));
  if (!width || !height) {
    return [612, 792];
  }
  return [width, height];
}
module.exports = {
  ACTION_TYPES: ACTION_TYPES,
  emptyDocument: emptyDocument,
  isPdf: isPdf,
  hasPdf: hasPdf,
  pdfEntries: pdfEntries,
  pageSource: pageSource,
  revoke: revoke,
  addUser: addUser,
  resolveSigner: resolveSigner,
  renameUser: renameUser,
  removeUser: removeUser,
  addAction: addAction,
  stripSignatures: stripSignatures,
  actionById: actionById,
  removeAction: removeAction,
  actionsOnPage: actionsOnPage,
  copy: copy,
  openPdf: openPdf,
  openPdfs: openPdfs,
  hydrate: hydrate
};